import { CaretLeftIcon as PhosphorCaretLeftIcon } from "@phosphor-icons/react/dist/ssr/CaretLeft";

import { createAppIcon } from "@/components/createAppIcon";

export const ChevronLeftIcon = /* @__PURE__ */ createAppIcon(PhosphorCaretLeftIcon);
